import React from 'react';
import { ClockIcon, PackageIcon, MapPinIcon, ShieldCheckIcon } from 'lucide-react';
export function TrustStats() {
  const stats = [{
    icon: ClockIcon,
    title: 'Emergency Courier Providers',
    description: 'Professional drivers available for hire at short notice, 24/7.'
  }, {
    icon: PackageIcon,
    title: '5000+ Jobs Completed',
    description: 'Driver supply and deliveries across the UK.'
  }, {
    icon: MapPinIcon,
    title: 'Nationwide UK Coverage',
    description: 'Drivers available in every corner of the country.'
  }, {
    icon: ShieldCheckIcon,
    title: 'Vetted Professional Drivers',
    description: 'Experienced, insured, and ready to work.'
  }];
  return <section className="py-12 bg-white relative z-20 -mt-16" data-id="element-203">
      <div className="container mx-auto px-4" data-id="element-204">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-205">
          {stats.map((stat, index) => {
          const Icon = stat.icon;
          return <div key={index} className="bg-white rounded-xl shadow-lg border border-slate-100 p-6 flex flex-col items-center text-center hover:shadow-xl transition-shadow" data-id="element-206">
                <div className="h-14 w-14 bg-blue-50 rounded-full flex items-center justify-center mb-4" data-id="element-207">
                  <Icon className="h-7 w-7 text-primary" data-id="element-208" />
                </div>
                <h3 className="font-bold text-slate-900 mb-2" data-id="element-209">{stat.title}</h3>
                <p className="text-sm text-slate-600" data-id="element-210">{stat.description}</p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}